import React, { FunctionComponent, ReactElement, useState } from 'react'
import { Text, View, ViewStyle } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { Button, ButtonTypes } from '../../atoms/button/Button'
import { XButton } from '../../atoms/xButton/XButton'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export type BannerProps = {
  show: boolean
  bannerContent: ReactElement<Text | View>
  buttonTitle?: string
  onPress?: () => void
  backgroundColor?: string
  style?: ViewStyle
  dismissible?: boolean
}

const BannerContainer = styled.View<{ backgroundColor: string; theme: ThemeType }>(
  ({ backgroundColor, theme: { spacing } }) => ({
    backgroundColor,
    padding: spacing['24px'],
    marginTop: '-10px',
  }),
)

const OutlineButton = styled(Button)<{ theme: ThemeType }>(({ theme: { spacing, colors } }) => ({
  marginTop: spacing['16px'],
  borderWidth: '1px',
  borderColor: colors.components.banner.outlineButton.border,
  borderRadius: spacing['4px'],
  backgroundColor: 'transparent',
}))

const BannerContentWrapper = styled.View({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
})

const ContentSection = styled.View({
  flex: 1,
})

const DismissButtonWrapper = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  marginLeft: spacing['16px'],
}))

/**
 * A banner that can show some text and also a button for the user to interact with
 */
export const Banner: FunctionComponent<BannerProps> = ({
  show,
  bannerContent,
  onPress,
  buttonTitle,
  backgroundColor,
  style,
  dismissible,
}) => {
  const { colors } = useTheme()
  const [showBanner, setShowBanner] = useState<boolean>(show)

  return show && showBanner ? (
    <BannerContainer testID={tID('Banner')} backgroundColor={backgroundColor || colors.backgroundActive} style={style}>
      <BannerContentWrapper>
        <ContentSection>
          {bannerContent}
          {Boolean(buttonTitle) && onPress ? (
            <OutlineButton onPress={() => onPress()} title={buttonTitle ?? ''} buttonType={ButtonTypes.PRIMARY} />
          ) : null}
        </ContentSection>
        {dismissible && (
          <DismissButtonWrapper>
            <XButton showExitText={false} onPress={() => setShowBanner(false)} testID={tID('banner-dismiss')} />
          </DismissButtonWrapper>
        )}
      </BannerContentWrapper>
    </BannerContainer>
  ) : null
}
